import { Location } from '@angular/common';
import { Component, ContentChild, Input, OnInit, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolCoursesService } from '@digilize/language-school/data';

@Component({
  selector: 'lsc-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageContainerComponent implements OnInit {
  @Input() headerText: string = null;
  @Input() width: 'sm' | 'lg' = 'lg';
  @Input() backText: string = null;
  @Input() customRelativeRedirect: null | string = null;
  @ContentChild('topRightCorner')
  topRightCorner?: TemplateRef<any>;
  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private router: Router,
    private schoolCoursesService: SchoolCoursesService
  ) {}

  ngOnInit() {}
  backLocation() {
    if (this.customRelativeRedirect) {
      this.router.navigate([this.customRelativeRedirect], { relativeTo: this.route });
      return;
    }
    this.router.navigate(['course', this.schoolCoursesService.currentCourseId]);
  }
}
